import React, { FC } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

import placeholderImage from "./placeholder.png";

interface StakeholdersTableDataPlaceholderProps {
  onAddStakeholder?: () => void;
}

const StakeholdersTableDataPlaceholder: FC<
  StakeholdersTableDataPlaceholderProps
> = ({ onAddStakeholder }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 400,
        py: 4,
      }}
    >
      <Box
        component="img"
        src={placeholderImage}
        alt="No stakeholders illustration"
        sx={{
          width: 130,
          height: 100,
          mb: 3,
          opacity: 0.7,
        }}
      />

      <Stack spacing={3} alignItems="center" textAlign="center">
        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
          {t(
            "stakeholders.noStakeholdersYet",
            "No stakeholders have been set up yet.",
          )}
        </Typography>

        {onAddStakeholder && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<FeatherIcon icon="plus" size={20} />}
            onClick={onAddStakeholder}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: 2,
            }}
          >
            {t("stakeholders.addStakeholder", "Add stakeholder")}
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default StakeholdersTableDataPlaceholder;
